import { AxiosRequestConfig } from "axios"
import { apis } from "service"

const BASE_URL = 'https://xxl6-bbr3-kxzs.m2.xano.io/api:'
const update_stage_tag = BASE_URL + 'FiAQK2sE/edit_stage_status'
const update_digital_interest = BASE_URL + 'FiAQK2sE/update_digital_interest_v3'

export const update_stage = async(data:{opportunity_id:number,status:string,type:string}) => {
    const payload: AxiosRequestConfig<{opportunity_id:number,status:string,type:string}> = {
        data:{
            opportunity_id: data.opportunity_id,
            status: data.status,
            type : data.type
        }
    }

    return await apis.patch(update_stage_tag, payload)
}

export const updateDigitalInterest = async(data: {company_id?: number, partner_id?:number, digital_interest: string}) => {
    const payload: AxiosRequestConfig<{company_id?: number, partner_id?:number, digital_interest: string}> = {
        data:{
            company_id: data.company_id,
            partner_id: data.partner_id,
            digital_interest: data.digital_interest
        }
    }

    return await apis.post(update_digital_interest, payload)
}